import smoothscroll from 'smoothscroll-polyfill';
import 'broadcastchannel-polyfill';
import './polyfills/append';
import './polyfills/flat';
import './polyfills/matches';
import './polyfills/closest';

smoothscroll.polyfill();
